import { Stack, styled } from '@mui/material';

export const Container = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
}));
